import styled from "styled-components";
import { Link } from "react-router-dom";

export const ListWrapper = styled.section`
    width: 70vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -35vw;
    margin-right: -35vw;
    display: flex;
    flex-direction: column;
    text-align: start;
    padding: 0px 40px;
    padding-bottom: 40px;

        @media (max-width: 1400px) {
    width: 90vw; 
    position: relative; 
    left: 50%; 
    right: 50%; 
    margin-left: -45vw; 
    margin-right: -45vw; 
    display: flex; 
    flex-direction: column; 
    text-align: start; 
    padding: 0px 40px; 
    padding-bottom: 40px;
    }
        @media (max-width: 1000px) {
    width: 70vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -35vw;
    margin-right: -35vw;
    display: flex;
    flex-direction: column;
    text-align: start;
    padding: 0px 40px;
    padding-bottom: 40px;
    }
    @media (max-width: 768px) {
    width: 90vw; 
    position: relative; 
    left: 50%; 
    right: 50%; 
    margin-left: -45vw; 
    margin-right: -45vw; 
    display: flex; 
    flex-direction: column; 
    text-align: start; 
    padding: 0px 20px; 
    padding-bottom: 40px;
    }
`;

export const TileImage = styled.img`
    width: 100%;
    aspect-ratio: 16/9;
    object-fit: cover;
    border-radius: 10px 10px 0 0;
    margin-bottom: 20px;
`;

export const List = styled.ul`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    list-style: none;
    padding: 0;
    margin: 0 auto;

    @media (max-width: 1000px) {
        grid-template-columns: 1fr;
    }
`;

export const Tile = styled.li`
    margin: 0;
`;

export const TileLink = styled(Link)`
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 10px;
  border: 2px solid rgb(240, 240, 240);
  box-shadow: 0 0 20px rgba(0,0,0,0.1);
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  &:focus-visible {
    outline: 3px solid rgba(0,0,0,0.35);
    outline-offset: 4px;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 30px 30px;

    @media (max-width: 768px) {
        padding: 20px 20px;
    }
`;

export const Name = styled.h3`
    font-weight: 700;
    font-size: 24px;
    margin: 0;

    @media (max-width: 768px) {
        font-size: 20px;
    }
`;

export const Description = styled.p`
    font-size: 18px;
    line-height: 1.4;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

export const LearnMore = styled.p`
  margin-top: auto;
  font-weight: 500;
  font-size: 16px;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
